
import { FlaskConical, Scale, Baby, TestTube } from 'lucide-react';
import ServiceCard from './ServiceCard';
import GenderRevealPricingTable from './GenderRevealPricingTable';
import { dnaServices, legalServices, genderRevealServices, drugTestingServices } from '../data/serviceData';

const ServiceCategories = () => {
  return (
    <div className="space-y-4">
      {/* Enhanced DNA Testing with gradient border */}
      <div className="relative group">
        <div className="absolute -inset-0.5 bg-gradient-to-r from-green-500 via-blue-500 to-green-500 rounded-lg blur opacity-75 group-hover:opacity-100 transition duration-1000 group-hover:duration-200 animate-gradient-shift"></div>
        <div className="relative">
          <ServiceCard 
            title="DNA Testing Solutions" 
            description="Comprehensive genetic testing for various needs"
            items={dnaServices}
            icon={<FlaskConical size={20} className="text-white" />}
          />
        </div>
      </div>

      {/* Gender Reveal Testing */}
      <div className="relative group">
        <div className="absolute -inset-0.5 bg-gradient-to-r from-pink-500/80 via-blue-500/80 to-pink-500/80 rounded-lg blur opacity-75 group-hover:opacity-100 transition duration-1000"></div>
        <div className="relative">
          <GenderRevealPricingTable />
        </div>
      </div>

      {/* Drug Testing Services */}
      <div className="relative group">
        <div className="absolute -inset-0.5 bg-gradient-to-r from-orange-500/80 via-red-500/80 to-orange-500/80 rounded-lg blur opacity-75 group-hover:opacity-100 transition duration-1000"></div>
        <div className="relative">
          <ServiceCard 
            title="Drug Testing Services" 
            description="DOT and Non-DOT drug testing solutions"
            items={drugTestingServices}
            icon={<TestTube size={20} className="text-white" />}
          />
        </div>
      </div>

      {/* Legal Testing */}
      <div className="relative group">
        <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-500/80 via-green-500/80 to-blue-500/80 rounded-lg blur opacity-75 group-hover:opacity-100 transition duration-1000"></div>
        <div className="relative">
          <ServiceCard 
            title="Legal Testing Services" 
            description="Court-admissible testing for legal procedures"
            items={legalServices}
            icon={<Scale size={20} className="text-white" />}
          />
        </div>
      </div>
    </div>
  );
};

export default ServiceCategories;
